import Swiper from 'swiper';
import SectionTitleReveal from '../common/section-title-reveal';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import { Pagination, Navigation } from 'swiper/modules';
import { bindSwiperNavigationA11y } from '../common/syncSwiperNavigationA11y';

export default class Awards {

    constructor() {
        this.sections = document.querySelectorAll('.block-awards');
        this.instances = [];
        this.handleResize = this.debounce(this.rebuild.bind(this), 300);

        this.ready();
        window.addEventListener('resize', this.handleResize);
    }

    debounce(fn, delay) {
        let timer;
        return (...args) => {
            clearTimeout(timer);
            timer = setTimeout(() => fn.apply(this, args), delay);
        };
    }

    rebuild() {
        this.instances.forEach(obj => {
            obj.main?.destroy(true, true);
        });
        this.instances = [];
        this.ready();
    }

    ready() {
        if (this.sections.length === 0) return;

        this.sections.forEach(section => {

            const slider = section.querySelector('.swiper');
            if (!slider) return;

            const navigationNext = section.querySelector('.slider-button-next');
            const navigationPrev = section.querySelector('.slider-button-prev');
            const pagination = section.querySelector('.swiper-pagination');
            const desktopOffset = Math.max(28, (window.innerWidth - 1312) / 2);

            const swiperInstance = new Swiper(slider, {
                modules: [Pagination, Navigation],

                slidesPerView: 1,
                spaceBetween: 16,
                grabCursor: true,
                watchSlidesProgress: true,
                breakpoints: {
                    1024: {
                        slidesPerView: 'auto',
                        spaceBetween: 40,
                        slidesOffsetAfter: desktopOffset,
                    },
                },
                navigation: navigationNext && navigationPrev ? {
                    nextEl: navigationNext,
                    prevEl: navigationPrev,
                } : false,

                pagination: pagination ? {
                    el: pagination,
                    clickable: true,
                } : false,

            });

            bindSwiperNavigationA11y(swiperInstance);

            this.instances.push({ main: swiperInstance });
        });
    }
}

new SectionTitleReveal('.block-awards');

if (document.querySelector('.block-awards')) {
    new Awards();
}
